export function errorProcessor(errorStream) {
  return new Promise((resolve, reject) => {
    if (errorStream) {
      try {
        errorStream
          .json()
          .then(errorResponse => {
            resolve(errorResponse);
          })
          .catch(error => {
            reject(error);
          });
      } catch (error) {
        resolve(errorStream);
      }
    } else {
      resolve({});
    }
  });
}
